import { render, staticRenderFns } from "./StackTraceViewer.vue?vue&type=template&id=68bdac65&scoped=true"
import script from "./StackTraceViewer.vue?vue&type=script&lang=js"
export * from "./StackTraceViewer.vue?vue&type=script&lang=js"
import style0 from "./StackTraceViewer.vue?vue&type=style&index=0&id=68bdac65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bdac65",
  null
  
)

export default component.exports